<template>
  <div class="cl-inner">
    <!-- 搜索 -->
    <div class="person-search">
      <a-form layout="inline">
        <a-form-item class="name" label="标题">
          <a-input
            class="form-cell"
            type="text"
            placeholder="活动标题"
            v-model="queryParam.title"
          ></a-input>
        </a-form-item>

        <a-form-item label="类型">
          <a-select
            class="form-cell"
            placeholder="活动类型"
            v-model="queryParam.classifyId"
          >
            <a-select-option
              v-for="(item, index) in tags"
              :value="item.id"
              :key="index"
              >{{ item.tagName }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <a-form-item label="地区">
          <a-cascader
            :options="$store.state.common.address"
            :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
            placeholder="省市区"
            @change="addressChange"
            changeOnSelect
            style="width: 250px !important"
          />
        </a-form-item>

        <a-form-item label="时间">
          <a-range-picker
            format="YYYY-MM-DD HH:mm:ss"
            v-model="queryParam.time"
            :showTime="{
              hideDisabledOptions: true,
              defaultValue: [
                moment('00:00:00', 'HH:mm:ss'),
                moment('23:59:59', 'HH:mm:ss'),
              ],
            }"
          />
        </a-form-item>

        <a-form-item
          v-if="orgType == 2 || orgType == 6"
          class="name"
          label="学校"
        >
          <a-select
            :showSearch="true"
            :showArrow="false"
            labelInValue
            placeholder="搜索学校"
            style="width: 200px !important"
            :filterOption="false"
            @search="fetch"
            @change="searchChange"
            v-model="queryParam.schoolId"
            :notFoundContent="fetching ? undefined : null"
          >
            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
            <a-select-option
              v-for="d in data"
              :key="d.value"
              :value="d.value"
              >{{ d.text }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <a-form-item v-if="orgType == 3" class="name" label="课程方">
          <a-select
            :showSearch="true"
            :showArrow="false"
            labelInValue
            placeholder="搜索课程方"
            style="width: 200px !important"
            :filterOption="false"
            @search="fetch"
            @change="searchChange"
            v-model="queryParam.institutionId"
            :notFoundContent="fetching ? undefined : null"
          >
            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
            <a-select-option
              v-for="d in data"
              :key="d.value"
              :value="d.value"
              >{{ d.text }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <a-form-item class="search-oper">
          <a-button type="primary" @click="searchActivity()">查询</a-button>
          <a-button
            @click="
              () =>
                (queryParam = {
                  title: '',
                  classifyId: undefined,
                  provinceId: '',
                  cityId: '',
                  districtId: '',
                  time: [],
                  schoolId: undefined,
                  institutionId: undefined,
                })
            "
            >重置</a-button
          >
        </a-form-item>
      </a-form>
    </div>

    <!-- 操作 -->
    <div class="person-oper">
      <a-button type="primary" icon="plus" @click="add()">新建</a-button>
    </div>

    <!-- 表格数据 -->
    <a-table
      :columns="columns"
      :dataSource="dataSource"
      :loading="loading"
      :pagination="pagination"
      class="c-table"
      :rowKey="getRowKey"
      @change="handleTableChange"
    >
      <span slot="status" slot-scope="text, record">{{
        statusStr[record.status]
      }}</span>
      <span slot="action" slot-scope="text, record, index">
        <template>
          <a @click="changeStatus(record.id, record.status, index)">{{
            record.status == 0 || record.status == 2 ? '上架' : '下架'
          }}</a>
          <!-- <a-divider type="vertical" />
          <a @click="detail(record.id)">详情</a>-->
          <a-divider type="vertical" />
          <a @click="edit(record.id)">修改</a>
          <a-divider type="vertical" />
          <a @click="del(record.id)">删除</a>
        </template>
      </span>
      <span slot="institutionName" slot-scope="text, record">
        <template>
          <span
            >{{ record.institutionName }}
            <a-tag v-if="record.institutionType == 3" color="blue">
              高协
            </a-tag>
          </span>
        </template>
      </span>
    </a-table>
    <activity-form-modal ref="activityForm"></activity-form-modal>
  </div>
</template>
<script>
import CTable from '../../components/CTable'
import notification from 'ant-design-vue/es/notification'
import activity from '../../api/activity'
import moment from 'moment'
import ActivityFormModal from '../activity/ActivityFormModal'

const columns = [
  {
    title: '活动标题',
    dataIndex: 'title',
    key: 'title',
  },
  {
    title: '课程方',
    dataIndex: 'institutionTypeName',
    key: 'institutionTypeName',
    scopedSlots: { customRender: 'institutionTypeName' },
  },
  {
    title: '活动类型',
    dataIndex: 'tagName',
    key: 'tagName',
  },
  {
    title: '活动地点',
    dataIndex: 'detailAddress',
    key: 'detailAddress',
  },
  {
    title: '活动开始时间',
    dataIndex: 'startTime',
    key: 'startTime',
  },
  {
    title: '活动结束时间',
    dataIndex: 'endTime',
    key: 'endTime',
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '创建时间',
    dataIndex: 'gmtCreate',
    key: 'gmtCreate',
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  name: 'activityList',
  props: ['orgType'],
  data() {
    return {
      tags: [],
      statusStr: ['待上架', '上架中', '已下架', '已删除'],
      dataSource: [],
      columns,
      options: [], //省市区
      citys: [], //市
      queryParam: {
        title: '',
        classifyId: undefined,
        provinceId: '',
        cityId: '',
        districtId: '',
        time: [],
        schoolId: undefined,
        institutionId: undefined,
      }, //查询参数
      loading: false,
      pagination: {
        showTotal: (total) => `总共 ${total} 条`, // 显示总数
      },
      data: [],
      value: [],
      fetching: false,
    }
  },
  components: {
    CTable,
    ActivityFormModal,
  },
  methods: {
    moment,
    fetch(value) {
      if (this.orgType != 1) {
        console.log('fetching', value)
        this.data = []
        this.fetching = true
        if (this.orgType == 2) {
          let schoolName = value
          activity.searchSchool({ schoolName }).then((res) => {
            const data = res.data.map((item) => ({
              text: item.schoolName,
              value: item.id + '',
            }))
            console.log(data)
            this.data = data
            this.fetching = false
          })
        }
        if (this.orgType == 3) {
          let institutionName = value
          activity.searchInstitution({ institutionName }).then((res) => {
            const data = res.data.map((item) => ({
              text: item.institutionName,
              value: item.id + '',
            }))
            this.data = data
            this.fetching = false
          })
        }
      }
    },
    searchChange(value) {
      console.log('searchChange', value)
      Object.assign(this, {
        value,
        data: [],
        fetching: false,
      })
    },
    addressChange(value) {
      if (value.length == 1) {
        this.queryParam.provinceId = value[0]
        this.queryParam.cityId = value[1]
        this.queryParam.districtId = value[2]
      }
      if (value.length == 2) {
        this.queryParam.provinceId = value[0]
        this.queryParam.cityId = value[1]
        this.queryParam.districtId = value[2]
      }
      if (value.length == 3) {
        this.queryParam.provinceId = value[0]
        this.queryParam.cityId = value[1]
        this.queryParam.districtId = value[2]
      }
    },
    searchActivity() {
      let params = this.queryParam
      let orgType = this.orgType //1平台活动2学校活动3课程方活动
      let provinceId = params.provinceId ? params.provinceId : ''
      let cityId = params.cityId ? params.cityId : ''
      let districtId = params.districtId ? params.districtId : ''
      let startTime = params.time[0] ? params.time[0].toDate() : ''
      let endTime = params.time[1] ? params.time[1].toDate() : ''
      let title = params.title
      let classifyId = params.classifyId
      let schoolId = params.schoolId != undefined ? params.schoolId.key : ''
      let institutionId =
        params.institutionId != undefined ? params.institutionId.key : ''

      let newParms = { orgType }
      if (provinceId != '') {
        newParms.provinceId = provinceId
      }
      if (cityId != '') {
        newParms.cityId = cityId
      }
      if (districtId != '') {
        newParms.districtId = districtId
      }
      if (startTime != '') {
        newParms.startTime = startTime
      }
      if (endTime != '') {
        newParms.endTime = endTime
      }
      if (title != '') {
        newParms.title = title
      }
      if (classifyId != undefined) {
        newParms.classifyId = classifyId
      }
      if (this.orgType == 2 && schoolId != '') {
        newParms.schoolId = schoolId
      }
      if (this.orgType == 3 && institutionId != '') {
        newParms.institutionId = institutionId
      }
      this.getActivityList(newParms)
    },
    //活动列表
    getActivityList(params) {
      this.loading = true
      if (this.orgType == 1) {
        activity.sysList(params).then((res) => {
          console.log('数据：', res)
          this.pagination = res.data.pagination
          this.dataSource = res.data.list
          this.loading = false
        })
      }
      if (this.orgType == 2) {
        activity.schoolList(params).then((res) => {
          console.log('数据：', res)
          this.pagination = res.data.pagination
          this.dataSource = res.data.list
          this.loading = false
        })
      }
      if (this.orgType == 3) {
        activity.institutionList(params).then((res) => {
          console.log('数据：', res)
          this.pagination = res.data.pagination
          this.dataSource = res.data.list
          this.loading = false
        })
      }
    },
    handleTableChange(pagination, filters, sorter) {
      // console.log(pagination);
      const pager = { ...this.pagination }
      pager.current = pagination.current
      this.pagination = pager
      this.getActivityList({
        orgType: this.orgType,
        currentPage: pagination.current,
      })
    },
    changeStatus(id, status, index) {
      let statusNew = null
      let msg = ''
      if (status == 0 || status == 2) {
        statusNew = 1
        msg = '上架'
      }
      if (status == 1) {
        statusNew = 2
        msg = '下架'
      }
      if (statusNew == 1 || statusNew == 2) {
        if (this.orgType == 1) {
          activity.sysUpOrDown({ id, status: statusNew }).then((res) => {
            this.dataSource[index].status = statusNew
            notification.success({
              message: '消息',
              description: msg + '成功！',
            })
          })
        }
        if (this.orgType == 2) {
          activity.schoolUpOrDown({ id, status: statusNew }).then((res) => {
            this.dataSource[index].status = statusNew
            notification.success({
              message: '消息',
              description: msg + '成功！',
            })
          })
        }
        if (this.orgType == 3) {
          activity
            .institutionUpOrDown({ id, status: statusNew })
            .then((res) => {
              this.dataSource[index].status = statusNew
              notification.success({
                message: '消息',
                description: msg + '成功！',
              })
            })
        }
      }
    },
    getRowKey(record, index) {
      return index;
    },
    //新增
    add(value) {
      this.$refs.activityForm.init('add', { id: -1, orgType: this.orgType })
    },
    detail(value) {
      this.$refs.activityForm.init('detail', {
        id: value ? value : -1,
        orgType: this.orgType,
      })
    },
    edit(value) {
      this.$refs.activityForm.init('edit', {
        id: value ? value : -1,
        orgType: this.orgType,
      })
    },
    del(id) {
      let that = this
      this.$confirm({
        title: '提示',
        content: '您此次操作将会删除此活动，请确认您是否要删除?',
        okText: '是',
        okType: 'danger',
        cancelText: '否',
        onOk() {
          if (that.orgType == 1) {
            activity.sysDel({ id }).then((res) => {
              console.log(res)
              notification.success({
                message: '消息',
                description: '删除成功！',
              })
              that.getActivityList({
                orgType: that.orgType,
                currentPage: that.pagination.current,
              })
            })
          }
          if (that.orgType == 2) {
            activity.schoolDel({ id }).then((res) => {
              console.log(res)
              notification.success({
                message: '消息',
                description: '删除成功！',
              })
              that.getActivityList({
                orgType: that.orgType,
                currentPage: that.pagination.current,
              })
            })
          }
          if (that.orgType == 3) {
            activity.institutionDel({ id }).then((res) => {
              console.log(res)
              notification.success({
                message: '消息',
                description: '删除成功！',
              })
              that.getActivityList({
                orgType: that.orgType,
                currentPage: that.pagination.current,
              })
            })
          }
        },
        onCancel() {
          console.log('Cancel')
        },
      })
    },
  },
  created() {
    this.tags = this.$store.state.common.tags.filter(
      (item) => item.tagGroup == 3
    )
    this.$store.dispatch('getUserInfo').then((res) => {
      let roleId = res.accRole.id
      console.log('roleId', roleId)
    })
    this.getActivityList({ orgType: this.orgType })
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
.cl-inner {
  width: calc(100% - 40px);
  padding: 20px;
  background: white;
  margin: 20px auto;
}
.search-oper {
  button {
    margin: 0px 5px;
  }
}
.person-oper {
  margin: 20px 0px 30px;
}
</style>
